import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, LangChangeEvent, } from '@ngx-translate/core';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { v4 as uuidv4 } from 'uuid';
import { PreQualData } from 'src/app/model/pre-qual-data.model';
import { Base64 } from 'js-base64';
import { AdobeAnalyticsDigitalDataService } from 'src/app/service/adobe-analytics-digitaldata.service';


@Component({
  selector: 'co-aplicant-selection',
  templateUrl: './co-applicant-selection.component.html',
  styleUrls: ['./co-applicant-selection.component.less'],
  providers: [FrameworkUtilityComponent]
})
export class CoApplicantSelectionComponent implements OnInit {
  currentLang: string;
  coApplicantSelectionObj = { isCoApplicantPresent: "" };
  displayValidation: boolean = false;
  lang: string = "en"
  currentRoutePath: string;
  selectionY: boolean = null;
  selectionN: boolean = null;
  borderColorN: boolean = false;
  borderColorY: boolean = false;
  preQualDataObj: any;
  yesRadio: HTMLInputElement;
  noRadio: HTMLInputElement;
  flowType: any;
  prequalType = 'P';
  switchType = 'S';
  referralFlow: any;


  constructor(private util: UtilService, private _activatedRoute: ActivatedRoute,
    private i18nService: I18nService, private formUtiObj: FrameworkUtilityComponent,
    private storageService: WebStorageService, private translate: TranslateService,
    private utilService: UtilService, private router: Router, private adobeAnalyticsData: AdobeAnalyticsDigitalDataService) {

    this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
      if (sessionStorage.getItem("currLang") != e.lang) {
        sessionStorage.clear();
        if (sessionStorage.getItem("currLang") != null) {
          window.location.href = "https://www.cibc.com/" + sessionStorage.getItem("currLang") + "/personal-banking/mortgages.html";
        }
        else {
          window.location.href = "https://www.cibc.com/" + e.lang + "/personal-banking/mortgages.html"
        }
      }
    });
    this.preQualDataObj = new PreQualData();
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
      const path = this.utilService.determineNextRoute(this.currentRoutePath);
    });


    this._activatedRoute.queryParams.subscribe(params => {
      this.flowType = this.util.getFlowType(params);
      this.referralFlow = this.util.getReferral(params);
    });
    if (this.flowType?.type == this.switchType)
      this.preQualDataObj.flow_type = this.switchType;
    this.utilService.setSessionStorage(this.preQualDataObj);
  }
  ngOnInit(): void {
    this.preQualDataObj = this.util.getSessionStorage();
    this.formUtiObj.InitValues();
    window.scroll(0, 0);
    let currLang = sessionStorage.getItem("lang_ref");
    sessionStorage.setItem("currLang", currLang);
    if (!sessionStorage.getItem(CONSTANTS.nameInSessionStorage.TRANSACTION_ID)) {
      this.storageService.set(CONSTANTS.nameInSessionStorage.TRANSACTION_ID, btoa(String(uuidv4())), Scope.session);
    }

    this._activatedRoute.paramMap.subscribe(params => {
      this.i18nService.setCurrenttLang(params.get('lang'));
      this.currentLang = this.i18nService.getCurrentLang();
    });
    this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
      this.lang = e.lang || "en";
    });
    this.lang = sessionStorage.getItem("lang_ref");
  }

  ngAfterViewInit() {
    if (!sessionStorage.getItem("sessioncnc")) {
      sessionStorage.removeItem("sidebarTitle");
      document.getElementById("sidebarTitle").focus();
    }
  }

  buttonDisplay(selected) {
    if (this.displayValidation == true) {
      this.displayValidation = false;
    }
    if (selected == 'yes') {
      this.coApplicantSelectionObj.isCoApplicantPresent = "Y"
      this.selectionY = true;
      this.selectionN = false;
      this.borderColorY = true;
      this.borderColorN = false;
    }

    if (selected == 'no') {
      this.coApplicantSelectionObj.isCoApplicantPresent = "N"
      this.selectionY = false;
      this.selectionN = true;
      this.borderColorY = false;
      this.borderColorN = true;
    }

  }

  onSubmit() {

    if (this.borderColorY == false && this.borderColorN == false) {
      if (this.flowType?.type == this.switchType) {
        this.util.adobeAnalyticalErrorMsg("coapplicant-selection", "missing", "", null);
      }

      let temp = document.querySelector("#yes") as HTMLInputElement;
      temp.focus();
      this.displayValidation = true;
      document.getElementById("yesRadio").focus();
      $("#yesRadio").focus();
      return;
    }
    else {
      this.displayValidation = false;
    }

    this.preQualDataObj.is_coapplicant_applied = this.coApplicantSelectionObj.isCoApplicantPresent;
    this.utilService.is_coapplicant_applied.next(this.coApplicantSelectionObj.isCoApplicantPresent);
    let trans_Id = atob(sessionStorage.getItem(CONSTANTS.nameInSessionStorage.TRANSACTION_ID));
    this.preQualDataObj.request_no = trans_Id;
    let created_date = Date().toLocaleString();
    if (sessionStorage.getItem("redTm") != null) {
      let created_date = Base64.decode(sessionStorage.getItem("redTm"))
    }
    this.preQualDataObj.creation_date = new Date(created_date);
    if (this.referralFlow) {
      this.preQualDataObj.referralLink = window.location.href;
    }
    this.utilService.setSessionStorage(this.preQualDataObj);

    const path = this.utilService.determineNextRoute(this.currentRoutePath);
    this.router.navigate([path], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
  }


  handleKeyup(event, focused) {
    if (event.code === "Space") {
      if (focused == "yes") {
        this.selectionY = true;
        this.selectionN = false;
      }
      if (focused == "no") {
        this.selectionY = false;
        this.selectionN = true;
      }
      this.buttonDisplay(focused)
    }

    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      this.yesRadio = document.querySelector("#yes") as HTMLInputElement;
      this.noRadio = document.querySelector("#no") as HTMLInputElement;
      if (focused == "yes") { focused = "no" }
      else { focused = "yes" }
      if (focused == "yes") {
        this.selectionY = true;
        this.selectionN = false;
        this.yesRadio.focus();
      }
      if (focused == "no") {
        this.selectionY = false;
        this.selectionN = true;
        this.noRadio.focus();
      }
      this.buttonDisplay(focused)

    }
  }


}